module.exports = __webpack_public_path__ + "static/media/PropertyManagement.43520435.svg";